import type {
  Availability,
  Months,
  ProductKind,
  SpotClass,
  Tag,
} from "$apis/parkito2/types.gen.ts";
import { Encode } from "$shared/lib/query";
import { DateModel, PriceModel } from "$models";

export default class SpotClassModel implements SpotClass {
  constructor(private data: SpotClass) {}

  get availability(): Availability {
    return this.data.availability;
  }
  get isPopular(): boolean {
    return this.data.isPopular;
  }
  get price(): PriceModel {
    return new PriceModel(this.data.price);
  }
  get productKind(): ProductKind {
    return this.data.productKind;
  }
  get tags(): Tag[] {
    return this.data.tags;
  }

  getTagsWithPrice() {
    return this.data.tags.filter((t) => t.pricing && t.pricing.price > 0);
  }
  getTagsWithoutPrice() {
    return this.data.tags.filter((t) => !t.pricing || t.pricing?.price === 0);
  }

  getName(): string {
    return this.getTagsWithPrice().map((t) => t.name).join(" ");
  }

  getDescription(): string {
    return this.getTagsWithPrice().map((t) => t.description).join("\n");
  }
  getSellingPoints(): string[] {
    return this.getTagsWithoutPrice().map((t) => t.name);
  }

  getCheckoutUrl({ siteId, queueId, startDate, accessCode }: {
    siteId: string;
    queueId: string;
    startDate: DateModel;
    accessCode?: string;
  }): string {
    const queryParams = Encode.asQuery({
      tags: JSON.stringify(this.tags.map((t) => t.id)),
      startDate: startDate.format("YYYY-MM-DD"),
      accessCode,
    });
    return this.productKind === "Reserved"
      ? `#/store/${siteId}/queue/checkout/${queueId}?${queryParams}`
      : `#/store/${siteId}/permit/checkout/customer_info?${queryParams}`;
  }
}
